<header class="member-selection-dialog__header">
  {{ data.title | translate }}
</header>

<section class="member-selection-dialog__body">
  <ocp-member-multiselect-input
    [value]="selectedIds()"
    [options]="data.options"
    [placeholder]="data.placeholder ?? ''"
    [ariaLabel]="data.ariaLabel ?? data.title"
    (membersChange)="onMembersChange($event)"
  />
</section>

<div class="member-selection-dialog__actions">
  <button
    hlmBtn
    type="button"
    class="member-selection-dialog__submit-button"
    [disabled]="selectedIds().length === 0"
    (click)="onConfirm()"
  >
    <ocp-themed-icon name="checkmark.svg" mode="swap" />
    {{ data.confirmLabel ?? 'Ok' | translate }}
  </button>
  <button
    hlmBtn
    type="button"
    variant="secondary"
    class="member-selection-dialog__cancel-button"
    (click)="onCancel()"
  >
    <ocp-themed-icon name="cross.svg" />
    {{ data.cancelLabel ?? 'Cancel' | translate }}
  </button>
</div>
